export default "__VITE_ASSET__bCd81acd__"